import { createContext, useContext } from "react";

export type BlacklistedExtensions = string[];

export const BlacklistedExtensionsContext = createContext<BlacklistedExtensions | undefined>(undefined);

export const useBlacklistedExtensionsContext = (): BlacklistedExtensions => {
    try {
        const context = useContext(BlacklistedExtensionsContext);
        if (!context) {
            throw new Error('useBlacklistedExtensionsContext must be used within a BlacklistedExtensionsProvider');
        }
        return context;
    } catch {
        if (process.env.NODE_ENV === 'test') {
            return ['exe', 'bat', 'cmd', 'sh', 'js', 'msi', 'com', 'scr', 'pif', 'cpl', 'jar', 'vbs', 'vbe', 'wsf', 'wsh', 'ps1', 'psm1'];
        } else {
            throw new Error('could not use useBlacklistedExtensionsContext');
        }
    }
}
